<main class="parallel-main form-fields-sub-module">
	@if (field.type === 'TABLE_LIST') {
		<lbca-table-list
			[cardData]="cardInfo"
			[disabled]="false"
			[field]="field"
			[dataAttr]="dataAttr"
			[error]="[]"
			(clickEventEmmit)="eventParallelEmitter($event)"
			[setLineClickable]="true"
			[editParallel]="editParallel"
			[body]="tasks"
		></lbca-table-list>
	}
</main>
